export default "/images/360.svg?24ccdd1e1dbff7faa3cd1c98d2558ff7";